<script>
import Constants from '../constants';
import { forEach } from 'lodash';

import moveTextHover from '@/components/moveTextHover';
import commonParallaxItem from '@/components/commonParallaxItem';
import hoverDesign from '@/components/hoverDesign';
import standOutBtn from '@/components/standOutBtn';

export default {
  name: 'cdListInformation',
  components: {
    moveTextHover,
    commonParallaxItem,
    hoverDesign,
    standOutBtn,
  },
  data() {
    return {
      cdList: [],
      ready: false,
    };
  },
  async created() {
    this.init();
  },
  methods: {
    async init() {
      this.cdList = [];
      forEach(this.$t('message.discography.albums'), (v) => {
        this.cdList.unshift(v);
      });

      this.ready = true;
    },
    moveToAlbumPage(id) {
      this.$router.push({ name: Constants.ROUTER[`ALBUM${id}`], });
    },
    moveToSalePage(id) {
      this.$router.push({
        name: Constants.ROUTER[`DISTRIBUTION${id}`],
      });
    },
    isSale(id) {
      return Constants.ALBUM[`ALBUM${id}`].IS_SALE;
    },
  },
};
</script>

<template>
  <div class="cd-list-information" :class="$mq" v-if="ready">
    <div
      class="cd-item"
      v-for="(cdItem, i) in cdList" :key="cdItem.id"
      :class="[i % 2 === 1 ? 'odd' : 'even']"
    >
      <common-parallax-item
        class="jacket-container"
        :parallax-pattern="'blur'"
      >
        <div class="jacket"
          :class="`is-album-jacket-${cdItem.id}`"
          @click="moveToAlbumPage(cdItem.id)"
          :title="cdItem.name"
        > 
          <hover-design hover-design="verticalSquare"/>
        </div>
      </common-parallax-item>

      <div class="information-container f1">
        <p class="title"
          @click="moveToAlbumPage(cdItem.id)"
          :title="cdItem.name"
        >
          <move-text-hover :target-text="cdItem.name" />
        </p>
        <common-parallax-item
          :show-percentage="5"
          class="advertising-slogan"
          v-html="cdItem.advertisingSlogan"
          :parallax-pattern="'blur'"
        ></common-parallax-item>
        <p>
          <move-text-hover
            :target-text="cdItem.date"
            :is-hover-move="false"
            :is-pointer="false"
          />
        </p>
        <p class="buy-btn" v-if="isSale(cdItem.id)">
          <standOutBtn
            @onClickEvent="moveToSalePage(cdItem.id)"
            :msg="$t('message.information.buy')"
          />
        </p>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  @import "../css/variables";
  .cd-list-information {
    .cd-item {
      display: flex;
      align-items: center;
      padding: 0 10px;
      .jacket-container {
        max-width: 400px;
        height: 100%;
        display: flex;
        align-items: center;
        .jacket {
          width: 100%;
          aspect-ratio: 1 / 1;
          @include bgCenter;
          background-size: 100% 100%;
          cursor: pointer;
          filter: grayscale(0%);
          transition: 0.2s ease;
          &:hover {
            background-size: 115% 115%;
            filter: grayscale(100%);
          }
        }
      }
      .information-container {
        text-align: center;
        .title {
          cursor: pointer;
          :hover {
            color: $accentColor2;
          }
          border-bottom: 1px solid $textColorA50;
        }
        .buy-btn {
        }
      }
      &.even {
        flex-direction: row-reverse;
      }
      &.odd {
        background: $textColorA50;
        .information-container {
          color: $bgColor;
          .title {
            border-bottom: 1px solid $bgColorA50;
            }
          } 
      }
    }
    // responsible -----------------------------------------------
    &.viewLg {
      .cd-item {
        height: 600px;
        .jacket-container { width: 30%; }
        .information-container {
          .title {
            font-size: 1.4em;
            margin-bottom: 20px;
          }
          .advertising-slogan {
            font-size: 1em;
            margin-bottom: 20px;
          }
          .buy-btn {
            margin-top: 15px;
          }
        }
      }
    }
    &.viewMd {
      .cd-item {
        height: 400px;
        .jacket-container { width: 40%; }
        .information-container {
          .title {
            font-size: 1.1em;
            margin-bottom: 15px;
          }
          .advertising-slogan {
            font-size: 0.8em;
            margin-bottom: 15px;
          }
          .buy-btn {
            margin-top: 15px;
          }
        }
      }
    }
    &.viewSm {
      .cd-item {
        height: 600px;
        flex-flow: column;
        .jacket-container { width: 90%; }
        .information-container {
          width: 100%;
          .title {
            font-size: 1em;
            margin-bottom: 10px;
          }
          .advertising-slogan {
            font-size: 0.7em;
            margin-bottom: 10px;
          }
          .buy-btn {
            margin-top: 10px;
            margin-bottom: 20px;
          }
        }
      }
    }
  }
</style>
